import { Component, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { UserStatus } from 'src/app/enums/user.status';
import { AgentApplication } from 'src/app/model/agent.application';
import { Pagination } from 'src/app/model/Pagination';
import { AgentService } from 'src/app/services/agent.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-denied-applications',
    templateUrl: './denied-applications.component.html',
    styleUrls: ['./denied-applications.component.css'],
})
export class DeniedApplicationsComponent implements OnInit {
    applicationList: Array<AgentApplication> = [];
    pagination = new Pagination();
    form: FormGroup;

    constructor(
        private agentService: AgentService,
        private commonService: CommonService,
        private formBuilder: UntypedFormBuilder,
    ) {
        this.form = this.formBuilder.group({
            role: ['agent'],
            status: [UserStatus.disabled],
            start: ['0'],
            length: ['10'],
        });
    }

    ngOnInit() {
        this.getData();
    }

    getData() {
        this.form.get('start').setValue(this.pagination.start);
        this.form.get('length').setValue(this.pagination.length);
        this.agentService.getAgentApplications(this.form).subscribe({
            next: (application) => {
                setTimeout(() => {
                    this.applicationList = application?.responseBody?.data;
                    this.pagination.total = application?.responseBody?.resultTotal;
                }, 350);
            },
            error: (error) => {
            },
        });
    }

    receiveFilter(data: { name: string; value: number }) { }

    changeLength(len: number) {
        this.pagination.length = len;
        this.pagination.start = 0;
        this.getData();
    }

    changePage(page: number) {
        this.pagination.changePage(page);
        this.getData();
    }

    get controls(): any {
        return this.form.controls;
    }
}
